import React from 'react';

const BadgeConfig = {
  전체: { bg: 'bg-badge-gray/10', text: 'text-badge-gray' },
  사업장: { bg: 'bg-badge-blue/10', text: 'text-badge-blue' },
  중요: { bg: 'bg-badge-red/10', text: 'text-badge-red' },
  NEW: { bg: 'bg-orange-500', text: 'text-white' },
  default: { bg: 'bg-slate-100', text: 'text-slate-600' },
};

export default function BadgeItem({ type, label, className = '' }) {
  const config = BadgeConfig[type] || BadgeConfig.default;

  return (
    <div
      className={`inline-flex h-4.5 items-center justify-center rounded-xl px-2 py-1.5 text-[10px] font-bold whitespace-nowrap ${config.bg} ${config.text} ${className}`}
    >
      {label}
    </div>
  );
}
